import { render, staticRenderFns } from "./TrafficForecast.vue?vue&type=template&id=010718a6&scoped=true"
import script from "./TrafficForecast.vue?vue&type=script&lang=js"
export * from "./TrafficForecast.vue?vue&type=script&lang=js"
import style0 from "./TrafficForecast.vue?vue&type=style&index=0&id=010718a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010718a6",
  null
  
)

export default component.exports